export default (obj) => {
  const falseyValues = Object.values(obj).filter((n) => (n && n.length === 0) || !n);
  return falseyValues.length > 0;
};
